import { Injectable } from '@angular/core';
import { AuthData } from '../providers/auth';
import { AngularFire } from 'angularfire2';
import { Database } from '../providers/database';
import * as firebase from 'firebase';

@Injectable()

export class UserData {

  constructor(public auth: AuthData, public db: Database, public af: AngularFire) {}

  getProfile(client: any, userData) {
    let dataRef;
    dataRef = firebase.database().ref('/Clients/' + client.url + '/Users/' + userData.uid);

    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        if (snapshot.val()) {
          if (snapshot.val().id) {
            resolve(snapshot.val());
          } else {
            reject(false);
          }
        } else {
          reject(false);
        }
      });
    });
  }

  endRegister(client, dataUser, user) {
    // dataUser.uid = user.uid;
    console.log('user', user)
    console.log('cñlient', client)
    console.log('data', dataUser)
    return new Promise((resolve, reject) => {
      this.db.pushDatakey('/Clients/' + client.url + '/Users/', dataUser, user.uid)
      .then((result) => {
        resolve(dataUser);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }

  getNetworking(client, user) {
    let dataRef;
    dataRef = firebase.database().ref('/Clients/' + client.url + '/Users')
              .orderByChild('networking')
              .equalTo(true);
              // .limitToFirst(50);

    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        resolve(snapshot);
      });
    });
  }

  getMyContacts(client, user) {
    let dataRef;
    dataRef = firebase.database().ref('/Clients/' + client.url + '/___NetworkingUsers/' + user.uid);

    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        resolve(snapshot.val());
      });
    });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/user.ts